/* eslint-disable */
import jsSHA from 'jssha';
import { ugcVideo, trapFocus, releaseFocus } from '@utils/global-functions';
import { getCurrentView } from '@utils/breakpoints';
import { pubSub } from '@utils/PubSub';
import Cookies from 'js-cookie';
export default class SplitOverlay {
  constructor(context) {
    this.elements = {
      overlay: context,
      html: document.documentElement,
    };

    this.overlay = {
      closeEl: context.querySelector('.steps__close'),
      exitBtn: context.querySelector('#closeOverlay'),
      // Elements to inject with text from window.Brooklinen.EntranceOverlay
      // Note: 'cta_negative' refers to the button, not the wrapper div 'cta_neg'
      childEls: [
        'headline_mobile',
        'headline_desktop',
        'caption_mobile',
        'caption_desktop',
        'cta_positive',
        'cta_negative',
        'logo',
      ],
    };

    this.init();
  }

  init() {
    ugcVideo('hide');
    // exit overlay listeners
    document.addEventListener('keydown', (event) => {
      if (event.key?.includes('Escape')) this.closeModal();
    });
    this.closeModalEvtListeners(this.overlay.exitBtn);

    this.setUpOverlay();

    // in case, all steps are disabled in DY
    this.checkRemainingSteps();

    // window resizing event
    this.viewportListener();
  }

  showClose() {
    const closeDelay = 0;

    setTimeout(() => {
      this.overlay.closeEl.classList.add('active');
    }, closeDelay);
  }

  closeModal() {
    ugcVideo('show');
    const { overlay, html, skip } = this.elements,
      windowOverlay = window?.Brooklinen?.EntranceOverlay;
    if (overlay.querySelector('.steps--item.active')) {
      overlay.querySelector('.steps--item.active').classList.remove('active');
      overlay.removeAttribute('open');
      overlay.setAttribute('aria-hidden', 'true');
      const id = window.location.href.includes('#')
        ? window.location.href.split('#')[1]
        : false;
      if (id) {
        const el = document.querySelector(`#${id}`);
        el.scrollIntoView();
      }
      const isSmallOverlay = windowOverlay?.general?.overlay_size == 'small';
      if (isSmallOverlay) {
        document
          .querySelector('.splitOverlay--background')
          .classList.remove('active');
        html.classList.remove('lock-scroll-fixed');
        overlay.style.display = 'none';
        overlay.classList.remove('active');
      } else {
        setTimeout(() => {
          html.classList.remove('lock-scroll-fixed');
        }, 100);
        setTimeout(() => {
          overlay.style.transitionProperty = 'height';
          overlay.style.height = '0';
        }, 400);
      }

      // DY cookie for when modal closes
      document.cookie = '_dy_email_capture_closed=true; path=/';

      setTimeout(() => {
        overlay.classList.add('hidden');
        overlay.classList.remove('active', 'open');

        releaseFocus(overlay);
      }, 1000);
    }
  }

  closeModalEvtListeners(element) {
    element.addEventListener('click', () => {
      this.closeModal();
    });
  }

  setUpOverlay = async () => {
    const resp = await this.loadDYVariables();
    if (resp) {
      // when DY copies finished loading, setup bg color and display overlay
      const { overlay, html } = this.elements,
        stepWrapperEl = overlay.querySelector('.steps__wrapper'),
        windowOverlay = window.Brooklinen.EntranceOverlay,
        activeEl = overlay.querySelector(
          '.steps--item[data-initial-load="true"]'
        ),
        windowbGColor = windowOverlay.general.backgroundColor,
        textAlign = windowOverlay.general.text_align,
        negCtaPlacement = windowOverlay.general.negative_cta_placement,
        winW = window.innerWidth,
        bgImageDesktop =
          window.Brooklinen.EntranceOverlay.general.background_image_desktop,
        bgImageMobile =
          window.Brooklinen.EntranceOverlay.general.background_image_mobile;

      overlay.classList.remove('hidden');
      overlay.classList.add('active');

      const isSmallOverlay =
        windowOverlay?.general?.overlay_size == 'small' &&
        getCurrentView() != 'sml' &&
        getCurrentView() != 'med';
      const entranceOverlayHeight = isSmallOverlay
        ? '530'
        : activeEl.offsetHeight;
      if (isSmallOverlay) {
        overlay.classList.add('layout--small');
        document
          .querySelector('.splitOverlay--background')
          .classList.add('active');
        document.documentElement.classList.add('lock-scroll-fixed');
      } else {
        overlay.style.opacity = '1';
        overlay.style.height = `0`;
      }

      if (winW < 600) {
        overlay.style.backgroundImage = `url(${bgImageMobile})`;
      } else if (winW >= 600) {
        overlay.style.backgroundImage = `url(${bgImageDesktop})`;
      }
      setTimeout(() => {
        stepWrapperEl.style.maxHeight = `${entranceOverlayHeight}px`;
        overlay.style.maxHeight = `${entranceOverlayHeight}px`;
        overlay.style.transitionProperty = !isSmallOverlay
          ? 'height'
          : 'opacity';
        overlay.style.height = `${entranceOverlayHeight}px`;
        overlay.style.backgroundColor = `${windowbGColor}`;
        overlay.setAttribute('open', '');
        overlay.setAttribute('aria-hidden', 'false');
        this.overlay.exitBtn.focus();
        trapFocus(overlay);
        stepWrapperEl.classList.add(`${textAlign}`);
        stepWrapperEl.classList.add(`${negCtaPlacement}`);
        activeEl.classList.add('active');
        html.classList.add('lock-scroll-fixed');
        this.showClose();
      }, 400);

      if (isSmallOverlay) {
        overlay.classList.add('open');
      }
    }
  };

  loadDYVariables = async () => {
    // grab DY variables from window.Brooklinen.EntranceOverlay
    const { overlay } = this.elements,
      windowOverlay = window.Brooklinen.EntranceOverlay;
    let initialLoad = true;
    const smsFirst = windowOverlay.general.sms_first;

    // Swap the SMS and Email steps
    // https://jsfiddle.net/jltorresm/1ukhzbg2/2/
    if (smsFirst === 'true') {
      overlay.classList.add('sms--first');
      const newOrder = [0, 2, 1, 3],
        wrapper = document.getElementsByClassName('steps__wrapper'),
        items = wrapper[0].children,
        elements = document.createDocumentFragment();

      newOrder.forEach(function (i) {
        elements.appendChild(items[i].cloneNode(true));
      });

      wrapper[0].innerHTML = null;
      wrapper[0].appendChild(elements);

      document.querySelector('.step_2').id = 'step_3';
      document.querySelector('.step_3').id = 'step_2';
    }

    for (let i = 1; i < 5; i++) {
      const stepLevel = `step_${i}`,
        stepEl = overlay.querySelector(`#${stepLevel}`);

      this.injectOverlayText(i, stepEl, windowOverlay);
      this.ctaBtnEvtListeners(i, stepEl);
      this.inputFocusedListeners(stepEl);

      // determines the first enabled step
      if (initialLoad && stepEl.dataset.enabled === 'true') {
        stepEl.dataset.initialLoad = 'true';
        initialLoad = !initialLoad;
      }
    }

    return true;
  };

  injectOverlayText(index, steps, overlay) {
    const { childEls } = this.overlay;
    const stepLevel = `step_${index}`,
      logoSize = window.Brooklinen.EntranceOverlay.general.logo_size,
      headlineDesktopSize =
        window.Brooklinen.EntranceOverlay.general.desktop_h1_size,
      headlineMobileSize =
        window.Brooklinen.EntranceOverlay.general.mobile_h1_size;

    // iterate over window Brooklinen overlay objects and apply copy text to it's respective html elements
    // Since we're using querySelector, I was able to add desktop and mobile copy easily.
    childEls.forEach((el) => {
      steps[el] = steps.querySelector(`.${el}`);
      const queryEls = steps[el];
      if (queryEls) {
        const overlayText = overlay[stepLevel][el];
        if (el.includes('cta_pos')) {
          queryEls.innerHTML = overlayText || overlay.general[el];
        } else if (el.includes('cta_neg')) {
          // Get the negative CTA text from step-specific or general config
          const ctaText = overlayText || overlay.general[el];
          queryEls.innerHTML = ctaText;
          queryEls.classList.add(overlay[stepLevel].show_mobile_neg);

          // Hide the parent wrapper (.cta_neg) if there's no CTA text
          // This prevents empty buttons from taking up space in the overlay
          const ctaWrapper = queryEls.closest('.cta_neg');
          if (ctaWrapper) {
            if (!ctaText || ctaText.trim() === '') {
              ctaWrapper.style.display = 'none';
            } else {
              ctaWrapper.style.display = '';
            }
          }
        } else if (el.includes('logo')) queryEls.classList.add(logoSize);
        else if (el.includes('image')) queryEls.src = overlayText;
        else if (el.includes('headline_desktop')) {
          queryEls.classList.add(headlineDesktopSize);
          queryEls.innerHTML = overlayText;
        } else if (el.includes('headline_mobile')) {
          queryEls.classList.add(headlineMobileSize);
          queryEls.innerHTML = overlayText;
        } else queryEls.innerHTML = overlayText;
      }
    });

    // determine if steps are enabled
    steps.dataset.enabled = overlay[stepLevel].enabled;
  }

  addNextStepListener(index, currentEl, buttonEl) {
    // determines next steps based on current index
    buttonEl.addEventListener('click', (e) => {
      e.preventDefault();
      if (index == 2 || index == 3) this.validateInput(currentEl);
      else this.goToNextStep();
    });
  }

  validateInput(currentEl) {
    // validate email and phone number input
    const inputType = currentEl.querySelector('.js-overlay-input').type;
    const inputEl = currentEl.querySelector(
      `.js-overlay-input[type="${inputType}"]`
    );
    const validationRegex = {
      tel: /^1? ?\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
      email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    };

    const passedValidation = () =>
      validationRegex[inputType].test(inputEl.value);

    if (passedValidation()) {
      const validValue =
        inputType == 'tel'
          ? parseInt(inputEl.value.replace(/\D/g, ''))
          : inputEl.value;

      if (inputType == 'tel') this.postScriptSubmit(validValue, currentEl);
      else {
        currentEl.querySelector('form').classList.add('email-capture--loading');
        this.emailSubmit(validValue, currentEl);
      }
      const nanoText = window.Brooklinen?.partial[0].nano?.text;
      if (nanoText) this.updateNanoText(nanoText);
    } else this.outputError(inputType, currentEl);
  }

  updateNanoText(text) {
    let expires = '';

    const optInDeadline =
      window.Brooklinen?.nano?.[0]?.settings.opt_in_slide_expiration;
    let date, expired;
    if (optInDeadline) {
      const currentDate = new Date();
      date = new Date(optInDeadline);
      expired = date.getTime() < currentDate.getTime();
    } else {
      expired = false;
      date = new Date();
      date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);
    }

    if (!expired) {
      expires = '; expires=' + date.toUTCString();
      document.cookie = `_dy_nano_updated=${text}; expires=${expires}; path=/`;

      pubSub.publish('nudge:submitted');
    }
  }
  outputError(inputType, currentEl) {
    // depending on input type, add the appropriate text to error label
    let errorText = '';
    if (inputType == 'tel') {
      errorText = 'Enter a valid phone number';
    } else if (inputType == 'emailExists') {
      errorText = 'Oops! That email address is already in use.';
    } else {
      errorText = 'Enter a valid email address.';
    }
    const formEl = currentEl.querySelector('form'),
      inputEl = currentEl?.querySelector(
        `.js-overlay-input[type="${inputType}"]`
      ),
      errorLabel = formEl.querySelector('.email-input--message');
    inputEl?.classList.add('error');
    errorLabel.innerHTML = errorText;
    errorLabel.ariaHidden = false;
  }

  postScriptSubmit(phoneNum, currentEl) {
    const url =
        'https://brooklinen-ometria.herokuapp.com/postscript/add_subscriber',
      keyword = window.Brooklinen.EntranceOverlay.step_3.keyword,
      data = {
        phone: phoneNum,
        keyword: keyword,
      };

    fetch(url, {
      method: 'POST',
      body: JSON.stringify(data),
      dataType: 'json',
      mode: 'cors',
      contentType: 'application/json; charset=utf-8',
      headers: {
        'X-Brooklinen-Auth': '0acf4539a14b3aa27deeb4cbdf6e989f',
        'content-type': 'application/json; charset=utf-8',
        Accept: 'application/json',
      },
    })
      .then((res) => res.json())
      .then((response) => {
        window.postscript.identify({
          phone: phoneNum,
        });
        const setCookieOnSMSSubmit =
          window?.Brooklinen?.themeSettings?.gatedCookie &&
          window?.Brooklinen?.EntranceOverlay?.general.sms_first;

        try {
          heap.track('SMS Optin', {
            phone: phoneNum,
            signup_source: keyword,
          });
        } catch (e) {
          console.log(`Heap error ${e}`);
        }

        if (setCookieOnSMSSubmit) {
          this.setGatedCookie();
        }
        this.goToNextStep();
      })
      .catch((error) => console.error('Error:', error));
  }

  setGatedCookie() {
    const cookieName = window?.Brooklinen?.themeSettings?.gatedCookie?.name;
    const expiration = window?.Brooklinen?.themeSettings?.gatedCookie
      ?.expiration
      ? new Date(window?.Brooklinen?.themeSettings?.gatedCookie?.expiration)
      : null;
    Cookies.set(cookieName, true, {
      expires: expiration,
    });
  }

  emailSubmit(email, currentEl) {
    const data = [];
    const form = currentEl.querySelector('form');
    const dyKeyword = window.Brooklinen.EntranceOverlay.step_2.keyword;

    const utmSrc = {};
    const signupSrc = dyKeyword === '' ? 'overlay' : dyKeyword;
    const props = { signup_source: signupSrc, ...utmSrc };
    const timeStamp = new Date();
    const { htComponent } = form.dataset;
    const overlayType =
      !!htComponent && htComponent !== '' ? htComponent : 'overlay';

    const payload = {
      '@type': 'contact',
      '@collection': signupSrc,
      email: email,
      '@merge': true,
      marketing_optin: 'EXPLICITLY_OPTEDIN',
      timestamp_subscribed: timeStamp.toISOString(),
      properties: props,
    };

    fetch(window.Brooklinen?.ometriaEndpoint, {
      method: 'POST',
      dataType: 'json',
      mode: 'cors',
      contentType: 'application/json; charset=utf-8',
      headers: {
        'X-Brooklinen-Auth': '0acf4539a14b3aa27deeb4cbdf6e989f',
        'content-type': 'application/json; charset=utf-8',
      },
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((data) => {
        const shaObj = new jsSHA('SHA-256', 'TEXT');
        shaObj.update(email.toLowerCase());
        const emailHash = shaObj.getHash('HEX');
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          submittedEmail: emailHash,
        });

        //Used for Ometria identify in GTM
        dataLayer.push({
          event: 'dl_subscribe',
          formLocation: 'partial_overlay',
        });

        const emailAlreadyExists = !(
          data?.ometria_contact === 'created' ||
          (data?.ometria_contact_created && data?.shopify_contact_created)
        );
        const formWrapper = document.querySelector(
          '#splitOverlay .ecap-wrapper'
        );
        if (!emailAlreadyExists || !window?.Brooklinen?.ometriaErrorHandling) {
          try {
            heap.track('Email Optin', {
              email: email,
              signup_source: signupSrc,
            });
          } catch (e) {
            console.log(`Heap error ${e}`);
          }
          formWrapper
            ?.querySelector('.email-input')
            ?.classList?.remove('error');

          Cookies.set('_dy_email_submited', true);
          const setCookieOnEmailSubmit =
            window?.Brooklinen?.themeSettings?.gatedCookie &&
            !window?.Brooklinen?.EntranceOverlay?.general?.sms_first;
          if (setCookieOnEmailSubmit) {
            this.setGatedCookie();
          }

          this.goToNextStep();
        } else {
          formWrapper.querySelector('.email-input').classList.add('error');
          this.outputError(
            'emailExists',
            document.querySelector('#splitOverlay .ecap-wrapper')
          );
        }
        form.classList.remove('email-capture--loading');
        return data;
      })
      .catch((error) => {
        console.error(error);
      });
  }

  checkRemainingSteps() {
    // checks if all steps are completed or disabled, then close modal
    const { overlay } = this.elements;

    const stepStillEnabled = Array.from(
      overlay.querySelectorAll('.steps--item')
    ).some((el) => {
      return el.dataset.enabled.includes('true');
    });

    if (!stepStillEnabled) this.closeModal();
  }

  goToNextStep() {
    const { overlay } = this.elements,
      activeEl = overlay.querySelector('.steps--item.active'),
      activeHeight = activeEl.offsetHeight,
      windowHeight = window.innerHeight,
      windowOverlay = window.Brooklinen.EntranceOverlay;
    activeEl.dataset.enabled = 'false';
    activeEl.classList.remove('active');

    // display next enabled step
    const enabledEls = overlay.querySelectorAll(
      '.steps--item[data-enabled="true"]'
    );
    const enabledElsCount = enabledEls.length;

    if (enabledEls.length === 0) this.closeModal();

    const isSmallOverlay =
      windowOverlay?.general?.overlay_size == 'small' &&
      getCurrentView() != 'sml' &&
      getCurrentView() != 'med';
    const lastIndex = enabledEls.length - 1,
      nextEnabledEl = enabledEls[lastIndex],
      nextEnabledInner = nextEnabledEl.querySelector('.steps--inner'),
      stepWrapper = overlay.querySelector('.steps__wrapper'),
      newHeight = isSmallOverlay ? '530' : nextEnabledEl.offsetHeight;

    if (nextEnabledEl.classList.contains('sms') && windowHeight < 670) {
      // For iphone 7 (height is 667px) the legal text is too long and pushes
      // the overlay off the page, including the close x
      overlay.classList.add('sms-step');
      nextEnabledEl.classList.add('active');
    } else {
      overlay.style.maxHeight = `${newHeight}px`;
      overlay.style.height = `${newHeight}px`;
      stepWrapper.style.maxHeight = `${newHeight}px`;
      nextEnabledEl.classList.add('active');
      overlay.classList.remove('sms-step');
    }

    trapFocus(overlay, nextEnabledEl);
    this.checkRemainingSteps();
  }

  ctaBtnEvtListeners(index, steps) {
    // attachs event listener to positive & negative cta buttons
    steps.cta_positive = steps.querySelector('.cta_positive');

    if (index == 4) {
      // if last step, close modal
      this.closeModalEvtListeners(steps.cta_positive);
    } else {
      this.addNextStepListener(index, steps, steps.cta_positive);
      this.closeModalEvtListeners(steps.cta_negative);
    }
  }

  inputFocusedListeners(steps) {
    // attaches click event listener to hide error label and to remove error styling when input is in focus
    const inputEl = steps.querySelector('.js-overlay-input'),
      formEl = steps.querySelector('form'),
      errorLabel = steps.querySelector('.error__label');
  }

  viewportListener() {
    const { overlay } = this.elements,
      stepWrapper = overlay.querySelector('.steps__wrapper');

    // updates .steps__wrapper max-height
    window.addEventListener('resize', function (event) {
      const activeEl = overlay.querySelector('.steps--item.active');
      const winW = window.innerWidth;
      const bgImageDesktop =
          window.Brooklinen.EntranceOverlay.general.background_image_desktop,
        bgImageMobile =
          window.Brooklinen.EntranceOverlay.general.background_image_mobile;

      if (winW < 600) {
        overlay.style.maxHeight = `${activeEl.offsetHeight}px`;
        overlay.style.height = `${activeEl.offsetHeight}px`;
        stepWrapper.style.maxHeight = `${activeEl.offsetHeight}px`;
        overlay.style.backgroundImage = `url(${bgImageMobile})`;
      } else if (winW >= 600) {
        const isSmallOverlay =
          windowOverlay?.general?.overlay_size == 'small' &&
          getCurrentView() != 'sml' &&
          getCurrentView() != 'med';
        const overlayHeight = isSmallOverlay ? '530px' : '100vh';
        overlay.style.maxHeight = overlayHeight;
        overlay.style.height = overlayHeight;
        stepWrapper.style.maxHeight = overlayHeight;
        overlay.style.backgroundImage = `url(${bgImageDesktop})`;
      }

      // prevents css transitions when window resizes from desktop to mobile
      stepWrapper.classList.add('resizing');
      setTimeout(() => {
        stepWrapper.classList.remove('resizing');
      }, 1000);
    });
  }
}
